export default {
  id: 'customers',
  title: 'Customers',
  category: 'Admin',
  summary: 'Maintain the customer records that contracts, projects, and invoices hang from.',
  overview: 'Customers are the top of Timeclerk’s commercial hierarchy. Each customer can have contracts, which contain projects, which contain charge codes that employees use on timesheets.',
  howItWorks: [
    'Create a customer before adding contracts for that organization.',
    'Customer details hold identifying and contact information used across billing and reporting.',
    'From a customer you can create related contracts.'
  ],
  actions: [
    {
      name: 'Create customer',
      description: 'Opens a modal to add a new customer record to the system.'
    },
    {
      name: 'Open customer details',
      description: 'Edit customer information and manage related contracts.'
    },
    {
      name: 'Create contract (from customer)',
      description: 'Starts a new contract linked to this customer.'
    }
  ],
  tips: [
    'Keep customer names consistent with how they appear on invoices and in QuickBooks if you sync.'
  ],
  related: ['contracts', 'projects', 'invoices']
};



// WEBPACK FOOTER //
// ./client/help/content/customers.js